import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useSelector } from 'react-redux';
import { Pagination } from 'antd';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import DepartmentTable from './Common/DepartmentTable';
import SelectList from './Common/SelectList';
import AlertMessage from './Common/AlertMessage';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const AllDepartment = ({ isShow, setIsShow }) => {
  const departmentTable = [
    {
      Sno: 1,
      department: 'Accountant'
    },
    {
      Sno: 2,
      department: 'Sweeper'
    },
    {
      Sno: 3,
      department: 'Trainer'
    },
    {
      Sno: 4,
      department: 'Housekeeping'
    },
    {
      Sno: 5,
      department: 'Trainee'
    },
    {
      Sno: 6,
      department: 'StoreKeepper'
    },
    {
      Sno: 7,
      department: 'Consultant'
    },
    {
      Sno: 8,
      department: 'Trainee'
    },
    {
      Sno: 9,
      department: 'Cleaner'
    },
    {
      Sno: 10,
      department: 'Cook'
    },
    {
      Sno: 11,
      department: 'Trainee'
    },
    {
      Sno: 12,
      department: 'Helper'
    },
    {
      Sno: 13,
      department: 'Guard'
    },
    {
      Sno: 14,
      department: 'Trainee'
    },
    {
      Sno: 15,
      department: 'Trainee'
    },
    {
      Sno: 16,
      department: 'Fresher'
    },
    {
      Sno: 17,
      department: 'Plumber'
    },
    {
      Sno: 18,
      department: 'Washer'
    },
    {
      Sno: 19,
      department: 'Trainee'
    },
    {
      Sno: 20,
      department: 'Manager'
    },
    {
      Sno: 21,
      department: 'Incharge'
    },
    {
      Sno: 22,
      department: 'Moderator'
    },
    {
      Sno: 23,
      department: 'Loyer'
    },
    {
      Sno: 24,
      department: 'Advicer'
    },
    {
      Sno: 25,
      department: 'Supporter'
    },
    {
      Sno: 26,
      department: 'Main Incharge'
    },
    {
      Sno: 27,
      department: 'Co-ordiantor'
    },
    {
      Sno: 28,
      department: 'Sweeper'
    },
    {
      Sno: 29,
      department: 'Trainee'
    },
    {
      Sno: 30,
      department: 'Account Manager'
    },
    {
      Sno: 31,
      department: 'Health Adviser'
    },
    {
      Sno: 32,
      department: 'Doctor'
    },
  ];

  const [data, setData] = useState(departmentTable);
  const [page, setPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const dataRef = React.createRef();
  const { alert } = useSelector(state => state.alert);

  const isDelete = (item) => {
    const newData = data.filter(e => { return e.Sno !== item.Sno });
    setData(newData)
  };
  const handleDelete = (item) => {
    confirmAlert({
      message: "Are you sure you want to Delete?",
      buttons: [
        {
          label: 'Yes',
          onClick: () => isDelete(item)
        },
        {
          label: 'Cancel',
          onClick: () => null
        }
      ],
      overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
    })
  };

  const itemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <a>Previous</a>;
    } else if (type === 'next') {
      return <a>Next</a>;
    }
    return originalElement;
  };

  const indexOfLastPage = page * postPerPage;
  const indexOfFirstPage = indexOfLastPage - postPerPage;
  const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

  return (
    <div className='page_first_div '>
      <SubNav isShow={isShow} setIsShow={setIsShow} />
      <div className='page_sec_div'>
        <p className='page_topic inline-block'>All Departments</p>
        <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
          <Link to="/admin/department/" className='link block text-white text-sm'>
            <i className="fa-solid fa-square-plus mr-1"></i>
            Add
          </Link>
        </div>
        <section className='page_section min-h-[23rem]'>

          {/* showing success message when form updated */}
          {alert && <AlertMessage />}

          {/* selectors and search bars */}
          <form className='flex flex-col lg:flex-row justify-center items-center gap-4 px-4 xsm:px-8 py-4 2xl:justify-start'>
            <div className='font-lato w-full lg:w-auto'>
              <select className="selector w-full lg:w-80 bg-gray-100">
                <option value=''>--Select status--</option>
                <option value="Fitness" >Active</option>
                <option value="Growth">Inactive</option>
              </select>
            </div>
            <SearchBtn
              setSearchTerm={setSearchTerm}
            />
          </form>

          {/* show option and convert buttons */}
          <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
            <SelectList
              setPostPerPage={setPostPerPage}
              data={data}
            />
            <ConvertButtons
              data={data}
              ref={dataRef}
            />
          </div>

          {/* all department table data details */}
          <DepartmentTable
            data={currentPost}
            sortData={data}
            setData={setData}
            onDelete={handleDelete}
            searchTerm={searchTerm}
            ref={dataRef}
          />

          {/* paginations and table length */}
          <div className='px-4 xsm:px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
            <p className='text-sm text-gray-800'>
              showing {page} to {currentPost.length} of {data.length} entries
            </p>
            <Pagination
              total={data.length}
              onChange={value => setPage(value)}
              itemRender={itemRender}
              pageSize={postPerPage}
              current={page}
            />
          </div>
        </section>
      </div>
      <Footer />
    </div>
  )
}

export default AllDepartment;